/**
 * Braze Web SDK initialization.
 * In-app messages are disabled when the site is viewed inside the native app's webview
 * (the native app already uses Braze for in-app messaging).
 *
 * @see https://www.braze.com/docs/developer_guide/sdk_integration?sdktab=web
 */

// eslint-disable-next-line import/no-unresolved -- @braze/web-sdk from package.json
import * as braze from '@braze/web-sdk';

import { BRAZE_WEB_API_KEY_DEV, BRAZE_WEB_API_KEY_PROD, BRAZE_WEB_SDK_ENDPOINT } from 'constants/publicKeys';
import { getIsProduction } from 'utils';

/**
 * Initializes the Braze Web SDK for in-app messages and analytics.
 * No-op when running in native webview or when API key/endpoint are missing.
 */
export function initializeBraze() {
    if (window.isNativeApp) {
        return;
    }

    const isProd = getIsProduction();
    const apiKey = isProd ? BRAZE_WEB_API_KEY_PROD : BRAZE_WEB_API_KEY_DEV;
    const baseUrl = BRAZE_WEB_SDK_ENDPOINT;

    if (!apiKey || !baseUrl) {
        return;
    }

    try {
        braze.initialize(apiKey, {
            baseUrl,
            enableLogging: false,
            allowUserSuppliedJavascript: false,
        });
        braze.automaticallyShowInAppMessages();

        if (typeof window !== 'undefined') {
            window.braze = braze;
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Braze Web SDK initialization failed:', e);
    }
}
